import React, { useState, useEffect } from 'react';
import { Snackbar, Alert, Slide, SlideProps } from '@mui/material';
import WifiOffIcon from '@mui/icons-material/WifiOff';
import WifiIcon from '@mui/icons-material/Wifi';
import { usePWA } from '../../hooks/usePWA';

/**
 * Shows when user is offline
 * Auto-dismisses when back online
 */

function SlideTransition(props: SlideProps) {
  return <Slide {...props} direction="down" />;
}

export function OfflineIndicator() {
  const { isOnline } = usePWA();
  const [showOffline, setShowOffline] = useState(!isOnline);
  const [showBackOnline, setShowBackOnline] = useState(false);

  useEffect(() => {
    if (!isOnline) {
      setShowOffline(true);
      setShowBackOnline(false);
    } else {
      // If was offline and now online, show "back online" message
      if (showOffline) {
        setShowOffline(false);
        setShowBackOnline(true);

        // Auto-hide "back online" message after 3 seconds
        const timer = setTimeout(() => {
          setShowBackOnline(false);
        }, 3000);

        return () => clearTimeout(timer);
      }
    }
  }, [isOnline, showOffline]);

  return (
    <>
      {/* Offline indicator */}
      <Snackbar
        open={showOffline}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        TransitionComponent={SlideTransition}
        sx={{ top: { xs: 8, sm: 16 } }}
      >
        <Alert
          severity="warning"
          icon={<WifiOffIcon />}
          sx={{
            width: '100%',
            maxWidth: 400,
            boxShadow: 3,
          }}
        >
          你当前处于离线状态。某些功能可能无法使用。
        </Alert>
      </Snackbar>

      {/* Back online indicator */}
      <Snackbar
        open={showBackOnline}
        autoHideDuration={3000}
        onClose={() => setShowBackOnline(false)}
        anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
        TransitionComponent={SlideTransition}
        sx={{ top: { xs: 8, sm: 16 } }}
      >
        <Alert
          severity="success"
          icon={<WifiIcon />}
          onClose={() => setShowBackOnline(false)}
          sx={{
            width: '100%',
            maxWidth: 400,
            boxShadow: 3,
          }}
        >
          已重新连接到网络
        </Alert>
      </Snackbar>
    </>
  );
}
